import { db } from '../db/dexie';

const KEY = 'last_sync_cursor';

/**
 * Postgres `now()` is transaction *start* time, so a long-running transaction
 * can commit a row stamped earlier than a cursor we have already advanced past.
 * Re-reading a few seconds of overlap on every pull closes that window. The
 * merge is idempotent, so seeing a row twice costs nothing.
 */
const OVERLAP_MS = 5000;

export async function readCursor(): Promise<string> {
  const row = await db.meta.get(KEY);
  return (row?.value as string | undefined) ?? new Date(0).toISOString();
}

/** Cursor for the next pull: the newest row seen, wound back by the overlap. */
export async function writeCursor(newest: string): Promise<void> {
  const value = new Date(Math.max(0, Date.parse(newest) - OVERLAP_MS)).toISOString();
  await db.meta.put({ key: KEY, value });
}

export async function resetCursor(): Promise<void> {
  await db.meta.delete(KEY);
}

/** The largest `updated_at` across every row pulled in this cycle. */
export function newestOf(batches: Array<Array<{ updated_at: string }>>): string | null {
  let newest: string | null = null;
  for (const batch of batches) {
    for (const row of batch) {
      if (newest === null || row.updated_at > newest) newest = row.updated_at;
    }
  }
  return newest;
}
